function uuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00";
}

function spinner(e) {
    return (
        '<div class="spinner-border" role="status">\n' + '<span class="visually-hidden">Loading...</span>\n' + "</div>"
    );
}

const elRow = function (elSelector) {
    return $(elSelector).closest(".row");
};

const elementVisibility = function (groupSelector, visible) {
    Object.keys(groupSelector).forEach((key) => elRow(groupSelector[key])[visible ? "show" : "hide"]());
};

export { uuid, numberWithCommas, spinner, elRow, elementVisibility };
